const $inject = [];
const lbaMultiSelect = function () {
  return {
    restrict: 'A',
    scope:{
      settings: '<',
    },
    bindToController: true,
    controller: 'lbaMultiSelectCtrl',
    controllerAs: 'vm',
    template: require('./lbaMultiSelect.html')
  }
};

lbaMultiSelect.$inject = $inject;

export default lbaMultiSelect;



// WEBPACK FOOTER //
// ./src/components/lbaMultiSelect/lbaMultiSelectDir.js